import { createAction, props } from '@ngrx/store';
import { DossierCategory } from './dossier-category.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier category'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier category success', 
    props<{ listData: DossierCategory[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier category failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record dossier category',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record dossier category success', 
    props<{ singleData: DossierCategory }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record dossier category failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record dossier category',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record dossier category success'
);
export const addRecordFailure = createAction(
    '[Data] Add record dossier category failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record dossier category',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record dossier category success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record dossier category failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record dossier category',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record dossier category success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record dossier category failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier category',
);